const markerGroupRQKeys = {
  all: ['markerGroup'],
  list: () => [...markerGroupRQKeys.all, 'list'],
  idTitleMarkersList: () => [...markerGroupRQKeys.list(), 'idNaming'],
  details: () => [...markerGroupRQKeys.all, 'detail'],
  detail: (id) => [...markerGroupRQKeys.details(), id]
}

export default markerGroupRQKeys
